import { AnalyticsProvider } from '@cmpsr/analytics';
import { ComposerProvider } from '@cmpsr/components';
import { QueryClientProvider } from '@tanstack/react-query';
import { theme } from '@ui';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { queryClient } from './client/query';
import { AmplitudeProvider } from './context/me/amplitude.context';
import router from './router';
import { FeatureFlagProvider } from './services/feature-flag-provider';
import injectThemeProps from './services/theme-override.service';

export function App() {
  return (
    <ComposerProvider theme={injectThemeProps(theme)}>
      <QueryClientProvider client={queryClient}>
        {/* Are we getting anything from the AnalyticsProvider anymore? */}
        <AnalyticsProvider>
          <AmplitudeProvider>
            <FeatureFlagProvider>
              <RouterProvider router={createBrowserRouter(router)} />
            </FeatureFlagProvider>
          </AmplitudeProvider>
        </AnalyticsProvider>
      </QueryClientProvider>
    </ComposerProvider>
  );
}

export default App;
